
import React from 'react';
import { FormField } from '@/components/ui/form';
import IconInput from '@/components/auth/IconInput';
import { Building, MapPin, Globe, Phone } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { SaasSignupFormValues } from '@/schemas/saasSignupSchema';

interface BusinessInfoFieldsProps {
  form: UseFormReturn<SaasSignupFormValues & { captcha: string }>;
}

const BusinessInfoFields = ({ form }: BusinessInfoFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="company"
        render={({ field }) => (
          <IconInput
            name="company"
            label="Company Name"
            placeholder="Enter your company name"
            icon={Building}
            field={field}
          />
        )}
      />
      
      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <IconInput
            name="address"
            label="Address"
            placeholder="Enter your business address"
            icon={MapPin}
            field={field}
          />
        )}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField
          control={form.control}
          name="country"
          render={({ field }) => (
            <IconInput
              name="country"
              label="Country"
              placeholder="Enter your country"
              icon={Globe}
              field={field}
            />
          )}
        />
        
        <FormField
          control={form.control}
          name="phone"
          render={({ field }) => (
            <IconInput
              name="phone"
              label="Phone Number"
              placeholder="Enter your phone number"
              icon={Phone}
              field={field}
            />
          )}
        />
      </div>
    </>
  );
};

export default BusinessInfoFields;
